import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Avatar, Box, styled, Typography, useMediaQuery, useTheme } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { Fragment } from 'react/jsx-runtime';
import remarkGfm from 'remark-gfm';
import { useAppSelector } from '../../../../../../application/store/useStore';
import './styles.scss';
var MessageBox = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== 'isXs'; }
})(function (_a) {
    var theme = _a.theme, isXs = _a.isXs;
    return ({
        width: 'auto',
        backgroundColor: 'rgba(200, 255, 247, 1)',
        padding: '10px',
        borderRadius: '10px',
        boxShadow: isXs ? theme.customShadows.z8 : theme.customShadows.z4,
        color: 'rgba(0, 78, 67, 1)',
        maxWidth: '85%',
        whiteSpace: 'normal',
        wordWrap: 'break-word'
    });
});
var UserMessage = function (_a) {
    var message = _a.message, question_type = _a.question_type, time = _a.time;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var theme = useTheme();
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    if (!message)
        return _jsx(Fragment, {});
    return (_jsx(Box, { display: 'flex', flexDirection: 'column', children: _jsxs(Box, { display: 'flex', alignItems: 'flex-start', flexDirection: 'row-reverse', gap: '2px', children: [_jsx(Avatar, { sizes: 'small', variant: 'circular', sx: {
                        width: '27px',
                        height: '27px',
                        bgcolor: 'lightgrey'
                    }, alt: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name, src: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name }), _jsx(MessageBox, { isXs: isXs, children: question_type === 'audio' ? (_jsxs(Fragment, { children: [_jsx(Typography, { variant: 'body2', component: 'div', children: _jsx("span", { className: 'reactMarkDown', children: _jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], children: message }) }) }), _jsxs(Box, { mt: 0.1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsx(Box, { display: 'flex', gap: 0.1, alignItems: 'center', children: _jsx(Icon, { icon: 'solar:microphone-bold', width: 12, height: 12 }) }), _jsx(Typography, { fontSize: 10, color: theme.palette.text.secondary, display: 'block', align: 'right', children: time })] })] })) : (_jsxs(Fragment, { children: [_jsx(Typography, { variant: 'body2', component: 'div', children: _jsx("span", { className: 'reactMarkDown', children: _jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], children: message }) }) }), _jsx(Box, { display: 'block', textAlign: 'right', children: _jsx(Typography, { variant: 'caption', display: 'block', align: 'right', children: time }) })] })) })] }) }));
};
export default UserMessage;
